import r from "./_getNative.js";
var t = r, a = function() {
  try {
    var e = t(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), v = a;
export {
  v as default
};
//# sourceMappingURL=_defineProperty.js.map
